export const COOKIE_NAME = "cookieConsent";
export const VIDEO_ID = "8KyJe2gibSk";
export const CALENDAR_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ3pE7Z-DjEJDmOEQog7FYxQLSRHW4JA70uS4iEy1NHF26n3iL50o8tOiut54Ic9SHufNHtb8W7c?gv=true";
export const CALENDLY_URL = "https://calendly.com/tlewis-ba/meeting";
